import axios from "axios";
import React from "react";
import { useQuery } from "react-query";
import { serverUrl } from "../../nestserver";
import BirthdayCard from "../cards/BirthdayCard";

// Role-scoped by the backend (BirthdayService.findTodaysBirthdaysForRole):
// admin gets school-wide, instructor gets their classes, student gets their
// own class, parent gets their children.
async function getTodaysBirthdays() {
  const res = await axios({
    method: "get",
    url: serverUrl + "/birthday/list",
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
    },
  });
  return res.data?.result ?? [];
}

// Full tab-body rendering of today's birthdays (as opposed to the ambient,
// auto-hiding home-screen row) — shown explicitly when the user picks the
// "Birthday" tab, so an empty state is appropriate here.
export default function BirthdayFeed() {
  const birthdays = useQuery("todays-birthdays", getTodaysBirthdays);

  if (birthdays?.isLoading) {
    return (
      <div className="py-16 flex items-center justify-center text-gray-400">
        Loading birthdays...
      </div>
    );
  }

  if (!birthdays?.data?.length) {
    return (
      <div className="py-16 flex flex-col items-center justify-center text-gray-400">
        <div className="text-5xl mb-3">🎂</div>
        <div className="text-lg font-medium text-gray-500">
          No birthdays today
        </div>
        <div className="text-sm text-gray-400">Check back tomorrow!</div>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-6 p-4">
      {birthdays.data.map((person) => (
        <BirthdayCard key={person._id} data={person} />
      ))}
    </div>
  );
}
